// Файл index.js

import ReactDOM from 'react-dom/client';

import AppErrorBoundary from './components/AppErrorBoundary';
import Page_load_mobile_version
    from './page_load_mobile_version/page_load_mobile_version';
import RootComponent from './app_root';
import { initialize_app_theme } from './shared_code/app_themes/app_theme';
import { install_frontend_logging } from './utils/frontend_logger';
import { install_frontend_recovery } from './utils/frontend_recovery';
import reportWebVitals from './utils/reportWebVitals';
import {
    install_resize_observer_error_filter,
} from './utils/resize_observer_error_filter';
import { Navigate, Route } from './utils/simple_router';

import './lk_templates_styling/shared_variables.css';
import './shared_code/app_themes/theme_blue.css';
import './shared_code/app_themes/theme_sky.css';
import './shared_code/app_themes/theme_light.css';
import './shared_code/app_themes/theme_dark.css';
import './shared_code/app_themes/theme_graphite.css';
import './shared_code/app_themes/theme_emerald.css';
import './shared_code/app_themes/theme_lavender.css';
import './shared_code/app_themes/theme_arctic.css';
import './shared_code/app_themes/theme_sakura.css';
import './shared_code/app_themes/theme_sand.css';
import './shared_code/app_themes/theme_midnight.css';
import './shared_code/app_themes/theme_neon.css';
import './shared_code/app_themes/theme_aurora.css';
import './shared_code/app_themes/theme_space.css';
import './shared_code/app_themes/theme_space_nebula.css';
import './shared_code/app_themes/theme_porcelain.css';
import './shared_code/app_themes/theme_ocean.css';
import './shared_code/app_themes/theme_copper.css';
import './shared_code/app_themes/theme_coral.css';
import './shared_code/app_themes/theme_mint.css';
import './shared_code/app_themes/theme_plum.css';
import './shared_code/app_themes/theme_nord.css';
import './shared_code/app_themes/theme_solar.css';
import './shared_code/app_themes/theme_rosewood.css';
import './shared_code/app_themes/theme_cloud.css';
import './shared_code/app_themes/theme_steel.css';
import './shared_code/app_themes/theme_amber.css';
import './shared_code/app_themes/theme_aqua.css';
import './shared_code/app_themes/theme_monochrome.css';
import './shared_code/app_themes/theme_base.css';
import './shared_code/layout_styles/common_layout.css';
import './shared_code/layout_styles/common_patterns.css';



initialize_app_theme();
install_resize_observer_error_filter();
install_frontend_logging();
install_frontend_recovery();

const mobile_route = (
    <Route
        path="/page_load_mobile_version"
        element={<Page_load_mobile_version />}
    />
);
const root_element = document.getElementById('root');

if (!root_element) {
    throw new Error('Не найден корневой элемент приложения');
}

const root = ReactDOM.createRoot(root_element);
root.render(
    <RootComponent
        ErrorBoundaryComponent={AppErrorBoundary}
        mobile_route={mobile_route}
        fallback_route={(
            <Route path="*" element={<Navigate to="/" replace />} />
        )}
        on_ready={() => {
            window.__POTALE_APP_READY__ = true;
        }}
    />
);

reportWebVitals();
